export default "__VITE_ASSET__DlG11QEu__"